import script from "./CreateTag.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTag.vue?vue&type=script&setup=true&lang=js"

import "./CreateTag.vue?vue&type=style&index=0&id=62ca83f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ca83f9"]])

export default __exports__